<template>

    <div class="tabson1" >
    <!--  <label >{{queryData.taxReportTime}} </label>
      <label >{{queryData.taxCompanyName}} </label>
      税金申报情况：<label style="color: #5daf34">{{ queryData.taxReportStatus | bspTableFilter({'1':'dict','2':dicts}) }}</label>
      <label style="color: #409EFF">&ensp;{{ queryData.taxPayStatus | bspTableFilter({'1':'dict','2':dicts}) }}</label>-->
<!--      <el-button type="primary" size="small" @click="backToCodeSet()" style="float: right">返回</el-button>-->

       <bsp-table
        :data.sync="list"
				id="accountTable"
        ref="accountTable"
        :ciic-data-filter.sync="listQuery"
        @ciic-data-refresh="_getBatchEmpByIdList"
        :showPagination="listQuery.page"
        width="100%"
      >
        <bsp-table-column
          field="A0010001"
          title="工号"

          width="10%">
          <template slot-scope="scope">{{ scope.row.A0010001 }}</template>
        </bsp-table-column>
        <bsp-table-column
          field="empName"
          title="姓名"
          width="10%">
          <template slot-scope="scope">{{ scope.row.empName }}</template>
        </bsp-table-column>
        <bsp-table-column
          field="idCardType"

          title="证照类型"
          width="10%">
          <template slot-scope="scope">{{ scope.row.idCardType  | bspTableFilter({'1':'dict','2':dicts}) }}</template>
        </bsp-table-column>
        <bsp-table-column
          field="idCard"
          label="证照号码"
          width="10%">
          <template slot-scope="scope">{{ scope.row.idCard }}</template>
        </bsp-table-column>
        <bsp-table-column
          field="national"
          title="国籍"

          width="10%">
          <template slot-scope="scope">{{ scope.row.national  | bspTableFilter({'1':'dict','2':dicts}) }}</template>
        </bsp-table-column>
        <bsp-table-column
          field="A0010006"
          title="性别"

          width="10%">
          <template slot-scope="scope">{{ scope.row.A0010006  | bspTableFilter({'1':'dict','2':dicts}) }}</template>
        </bsp-table-column>
        <bsp-table-column
          field="A0010009"
          title="出生日期"
          width="10%"
        >
          <template slot-scope="scope" >{{ scope.row.A0010009 }}</template>
        </bsp-table-column>
        <bsp-table-column
          field="A0010016"

          title="人员状态"
          width="10%">
          <template slot-scope="scope">{{ scope.row.A0010016  | bspTableFilter({'1':'dict','2':dicts}) }}</template>
        </bsp-table-column>
        <bsp-table-column
          field="A0010203"

          title="任职受雇从业类型"
          width="10%">
          <template slot-scope="scope">{{ scope.row.A0010203}}</template>
        </bsp-table-column>
        <bsp-table-column
          field="A0010204"
          title="入职年度就业情形"
          width="10%">
          <template slot-scope="scope">{{ scope.row.A0010204}}</template>
        </bsp-table-column>
         <bsp-table-column
           field="A0030001"

           title="手机号码"
           width="10%">
           <template slot-scope="scope">{{ scope.row.A0030001}}</template>
         </bsp-table-column>
         <bsp-table-column
           field="entryDate"

           title="任职受雇从业日期"
           width="10%">
           <template slot-scope="scope">{{ scope.row.entryDate}}</template>
         </bsp-table-column>
         <bsp-table-column
           field="leaveDate"

           title="离职日期"
           width="10%">
           <template slot-scope="scope">{{ scope.row.leaveDate}}</template>
         </bsp-table-column>
         <bsp-table-column
           field="isDisabled"

           title="是否残疾"
           width="10%">
           <template slot-scope="scope">{{ scope.row.isDisabled  | bspTableFilter({'1':'dict','2':dicts}) }}</template>
         </bsp-table-column>
         <bsp-table-column
           field="isMartyr"

           title="是否烈属"
           width="10%">
           <template slot-scope="scope">{{ scope.row.isMartyr  | bspTableFilter({'1':'dict','2':dicts}) }}</template>
         </bsp-table-column>
         <bsp-table-column
           field="isLonely"

           title="是否孤老"
           width="10%">
           <template slot-scope="scope">{{ scope.row.isLonely  | bspTableFilter({'1':'dict','2':dicts}) }}</template>
         </bsp-table-column>
         <bsp-table-column
           field="disabledNum"

           title="残疾人编号"
           width="10%">
           <template slot-scope="scope">{{ scope.row.disabledNum}}</template>
         </bsp-table-column>
         <bsp-table-column
           field="martyrNum"

           title="烈属证号"
           width="10%">
           <template slot-scope="scope">{{ scope.row.martyrNum}}</template>
         </bsp-table-column>
         <bsp-table-column
           field=""

           title="个人投资额"
           width="10%">
           <template slot-scope="scope"></template>
         </bsp-table-column>
         <bsp-table-column
           field=""

           title="个人投资比例(%)"
           width="12%">
           <template slot-scope="scope"></template>
         </bsp-table-column>
         <bsp-table-column
           field="remark"

           title="备注"
           width="10%">
           <template slot-scope="scope">{{ scope.row.remark}}</template>
         </bsp-table-column>
         <bsp-table-column
           field=""

           title="是否境外人员"
           width="10%">
           <template slot-scope="scope"></template>
         </bsp-table-column>
         <bsp-table-column
           field="empName"

           title="中文名"
           width="10%">
           <template slot-scope="scope">{{ scope.row.empName}}</template>
         </bsp-table-column>
         <bsp-table-column
           field=""

           title="涉税事由"
           width="10%">
           <template slot-scope="scope"></template>
         </bsp-table-column>
         <bsp-table-column
           field=""

           title="出生国家(地区)"
           width="10%">
           <template slot-scope="scope"></template>
         </bsp-table-column>
         <bsp-table-column
           field=""

           title="首次入境时间"
           width="10%">
           <template slot-scope="scope"></template>
         </bsp-table-column>
         <bsp-table-column
           field=""

           title="预计离境时间"
           width="10%">
           <template slot-scope="scope"></template>
         </bsp-table-column>
         <bsp-table-column
           field=""

           title="其他证照类型"
           width="10%">
           <template slot-scope="scope"></template>
         </bsp-table-column>
         <bsp-table-column
           field=""

           title="其他证照号码"
           width="10%">
           <template slot-scope="scope"></template>
         </bsp-table-column>
         <bsp-table-column
           field="A0010035"

           title="户籍所在地（省）"
           width="10%">
           <template slot-scope="scope">{{ scope.row.A0010035  | bspTableFilter({'1':'dict','2':dicts}) }}</template>
         </bsp-table-column>
         <bsp-table-column
           field=""

           title="户籍所在地（市）"
           width="10%">
           <template slot-scope="scope"></template>
         </bsp-table-column>
         <bsp-table-column
           field=""

           title="户籍所在地（区县）"
           width="10%">
           <template slot-scope="scope"></template>
         </bsp-table-column>
         <bsp-table-column
           field=""

           title="户籍所在地（详细地址）"
           width="10%">
           <template slot-scope="scope"></template>
         </bsp-table-column>
         <bsp-table-column
           field=""

           title="居住地址（省）"
           width="10%">
           <template slot-scope="scope"></template>
         </bsp-table-column>
         <bsp-table-column
           field=""

           title="居住地址（市）"
           width="10%">
           <template slot-scope="scope"></template>
         </bsp-table-column>
         <bsp-table-column
           field=""

           title="居住地址（区县）"
           width="10%">
           <template slot-scope="scope"></template>
         </bsp-table-column>
         <bsp-table-column
           field="A0030013"

           title="居住地址（详细地址）"
           width="10%">
           <template slot-scope="scope">{{ scope.row.A0030013  | bspTableFilter({'1':'dict','2':dicts}) }}</template>
         </bsp-table-column>
         <bsp-table-column
           field=""

           title="联系地址（省）"
           width="10%">
           <template slot-scope="scope"></template>
         </bsp-table-column>
         <bsp-table-column
           field=""

           title="联系地址（市）"
           width="10%">
           <template slot-scope="scope"></template>
         </bsp-table-column>
         <bsp-table-column
           field=""

           title="联系地址（区县）"
           width="10%">
           <template slot-scope="scope"></template>
         </bsp-table-column>
         <bsp-table-column
           field=""

           title="联系地址（详细地址）"
           width="10%">
           <template slot-scope="scope"></template>
         </bsp-table-column>
         <bsp-table-column
           field="email"

           title="邮箱"
           width="10%">
           <template slot-scope="scope">{{ scope.row.email}}</template>
         </bsp-table-column>
         <bsp-table-column
           field="A0050007"

           title="学历"
           width="10%">
           <template slot-scope="scope">{{ scope.row.A0050007  | bspTableFilter({'1':'dict','2':dicts}) }}</template>
         </bsp-table-column>
         <bsp-table-column
           field="A0120002"

           title="开户银行"
           width="10%">
           <template slot-scope="scope">{{ scope.row.A0120002  | bspTableFilter({'1':'dict','2':dicts}) }}</template>
         </bsp-table-column>
         <bsp-table-column
           field="A0120004"

           title="银行账号"
           width="10%">
           <template slot-scope="scope">{{ scope.row.A0120004}}</template>
         </bsp-table-column>
         <bsp-table-column
           field="A0070003"

           title="职务"
           width="10%">
           <template slot-scope="scope">{{ scope.row.A0070003  | bspTableFilter({'1':'dict','2':dicts}) }}</template>
         </bsp-table-column>
      </bsp-table>


    </div>
</template>
<script>
  import bspTable from "@/components/bsp/bsp-table/bsp-table";
  import bspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
  import {getTaxList,getTaxBatchById,updateTaxBatch,getBatchEmpByIdList,getEmpDetailByIdList,getEmpWagesDetailList} from "@/api/tax/tax";
  import {mapGetters} from 'vuex';
    export default {
      name: "tabson1",
      components: { bspTableColumn, bspTable},
      props:{
          currentTab:{
              type:String,
              default:''
          }
      },
      watch: {

      },
      created(){
        this.queryData=this.$route.query
         this._getBatchEmpByIdList()

      },
      mounted(){

      },
      computed: {
        ...mapGetters([
          'dicts',
          'pms'
        ]),
      },
      data() {
        return {
          queryData:null,
          list:[],
           listQuery:{
            limit: 20,
            page: 1,
            total: 0,
             taxReportTime:this.$route.query.taxReportTime,
             batchId:this.$route.query.batchId,

          }
      }
      },
      methods:{
        _getBatchEmpByIdList(){
            getBatchEmpByIdList(this.listQuery).then(res => {
            this.listQuery.total = res.data.total
            this.list = res.data.records
          } ).catch((error) => {
            console.log("错误信息"+error)
          })
        },
        backToCodeSet(){
          this.$router.go(-1)
        },

      }

    }
</script>
<style scoped="scoped">
	 #accountTable >>> .vxe-table .vxe-table--header-wrapper{
		 width: 100%;
	 }
</style>

